import parseJWT from "./parseJWT";

interface DecodedToken {
  exp?: number;
  [key: string]: any;
}

const isTokenValid = (token: string): boolean => {
  const decodedToken = parseJWT(token) as DecodedToken;

  if (!decodedToken || !decodedToken.exp) return false;

  const expiresAt = decodedToken.exp * 1000;
  const currentTime = new Date().getTime();
  const expiresIn = expiresAt - 60 * 1000 - currentTime;

  return expiresIn > 0;
};

export default isTokenValid;
